module.exports = __webpack_public_path__ + "img/plan5.abfddd76.svg";